var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { Popup } from '@progress/kendo-react-popup';
/**
 * @hidden
 */

var ListContainer = function (_super) {
  __extends(ListContainer, _super);

  function ListContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListContainer.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        width = _a.width,
        dir = _a.dir,
        itemsCount = _a.itemsCount,
        popupSettings = _a.popupSettings;
    return React.createElement(Popup, __assign({
      style: {
        width: width,
        direction: dir
      },
      contentKey: itemsCount
    }, popupSettings), children);
  };

  return ListContainer;
}(React.Component);

export default ListContainer;